import { createContext, useState, useMemo } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { node } from 'prop-types'
import { t } from '@lingui/core/macro'

export const modalContext = createContext({
  displayModal: _args => {},
})

export const ModalProvider = ({ children }) => {
  const displayModal = ({
    title,
    description,
    body,
    footer,
    confirm,
    cancel,
    primaryButtonText,
    submitDisabled,
  }) => {
    setHandleConfirm(confirm)
    setTitle(title)
    setDescription(description)
    setBody(body)
    setFooter(footer)
    setHandleClose(cancel)
    setOpen(true)
    primaryButtonText && setprimaryButtonText(primaryButtonText)
    submitDisabled !== null || (submitDisabled !== undefined && setSubmitDisabled(submitDisabled))
  }

  const [open, setOpen] = useState(false)
  const [handleClose, setHandleClose] = useState(() => {})
  const [handleConfirm, setHandleConfirm] = useState(() => {})
  const [title, setTitle] = useState(null)
  const [description, setDescription] = useState(null)
  const [body, setBody] = useState(null)
  const [footer, setFooter] = useState(null)
  const [submitDisabled, setSubmitDisabled] = useState(false)
  const [primaryButtonText, setprimaryButtonText] = useState('Confirm')

  const value = useMemo(
    () => ({
      displayModal,
    }),
    [],
  )

  return (
    <modalContext.Provider value={value}>
      {children}
      <Dialog
        open={open}
        onClose={() => {
          if (handleClose) {
            handleClose()
          }
          setOpen(false)
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        {description && (
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
          </DialogContent>
        )}
        {body && <DialogContent>{body}</DialogContent>}
        <DialogActions style={{ display: 'flex' }}>
          <DialogContent>{footer}</DialogContent>
          <Button
            onClick={() => {
              if (handleClose) {
                handleClose()
              }
              setOpen(false)
            }}
            color="primary"
          >
            {t`Cancel`}
          </Button>
          <Button
            onClick={() => {
              handleConfirm()
              setOpen(false)
            }}
            variant="outlined"
            color="primary"
            autoFocus
            disabled={submitDisabled}
          >
            {primaryButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    </modalContext.Provider>
  )
}

ModalProvider.propTypes = {
  children: node.isRequired,
}
